import { render, staticRenderFns } from "./mainTabBar.vue?vue&type=template&id=e6496b04&scoped=true&"
import script from "./mainTabBar.vue?vue&type=script&lang=js&"
export * from "./mainTabBar.vue?vue&type=script&lang=js&"
import style0 from "./mainTabBar.vue?vue&type=style&index=0&id=e6496b04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6496b04",
  null
  
)

export default component.exports